import Immutable from 'immutable';
import type { List, Map } from 'immutable';
import type { AnyAction, Reducer } from 'redux';
import { combineReducers } from 'redux-immutable';
import {
  CREATE_NEW_ROW,
  GET_TEMPLATES,
  START_TEST,
  UPDATE_ROW,
  type ABTestRow,
} from './actions';

const abtestDesignerReducer: Reducer<Map<string, unknown>, AnyAction> =
  Reflect.apply(combineReducers, undefined, [
    {
      templates: templatesReducer,
      state: stateReducer,
    },
  ]);

export default abtestDesignerReducer;
function templatesReducer(
  state: Map<string, unknown> = Immutable.fromJS({
    loading: false,
    data: undefined,
    errorMessage: undefined,
  }),
  action: AnyAction,
): Map<string, unknown> {

  switch (action.type) {
    case CREATE_NEW_ROW: {
      const data = (
        state.get('data') as List<Map<string, unknown>>
      ).toJS() as ABTestRow[];
      data.push({ name: action.newName, distributions: [] });
      return state.merge(
        Immutable.fromJS({
          data,
          loading: false,
          errorMessage: undefined,
        }),
      );
    }
    case GET_TEMPLATES: {
      return state.merge(
        Immutable.fromJS({
          data: action.data.data,
          loading: false,
          errorMessage: undefined,
        }),
      );
    }
    case `${GET_TEMPLATES}_LOADING`: {
      return state.merge({ loading: true, errorMessage: undefined });
    }
    case `${GET_TEMPLATES}_ERROR`: {
      return state.merge({
        loading: false,
        errorMessage: JSON.stringify(action),
      });
    }
    default: {
      return state;
    }
  }
}

function stateReducer(
  state: Map<string, unknown> = Immutable.fromJS({
    updating: false,
    starting: false,
  }),
  action: AnyAction,
): Map<string, unknown> {
  switch (action.type) {
    case `${UPDATE_ROW}_LOADING`: {
      return state.set('updating', true);
    }
    case UPDATE_ROW:
    case `${UPDATE_ROW}_ERROR`: {
      return state.set('updating', false);
    }
    case `${START_TEST}_LOADING`: {
      return state.set('starting', true);
    }
    case START_TEST:
    case `${START_TEST}_ERROR`: {
      return state.set('starting', false);
    }
    default: {
      return state;
    }
  }
}
